// The API carries the run time as 24-hour HH:MM in course local time; the page shows and
// takes h:mm with AM or PM, as the prototype does (DP-26 §1, DP-25 Part 1).

export type Meridiem = 'AM' | 'PM'

const TWELVE_HOUR = /^(0?[1-9]|1[0-2]):([0-5]\d)$/
const TWENTY_FOUR_HOUR = /^([01]\d|2[0-3]):([0-5]\d)$/

/** "18:05" → 6:05 PM. "00:30" → 12:30 AM. */
export function to12Hour(time: string): { time: string; meridiem: Meridiem } {
  const match = TWENTY_FOUR_HOUR.exec(time)
  if (!match) throw new Error(`Not a 24-hour time: ${time}`)
  const hours = Number(match[1])
  const hour = hours % 12 === 0 ? 12 : hours % 12
  return { time: `${hour}:${match[2]}`, meridiem: hours < 12 ? 'AM' : 'PM' }
}

/** 6:05 PM → "18:05". Null when the text is not h:mm with an hour from 1 to 12. */
export function to24Hour(time: string, meridiem: Meridiem): string | null {
  const match = TWELVE_HOUR.exec(time.trim())
  if (!match) return null
  const hour = (Number(match[1]) % 12) + (meridiem === 'PM' ? 12 : 0)
  return `${String(hour).padStart(2, '0')}:${match[2]}`
}

export function isTwelveHourTime(time: string): boolean {
  return TWELVE_HOUR.test(time.trim())
}

/** "06:00" → "6:00 AM". */
export function formatTime(time: string): string {
  const { time: text, meridiem } = to12Hour(time)
  return `${text} ${meridiem}`
}
